import styled from 'styled-components';

export const Container = styled.div`
  width: 50vw;
  box-sizing: border-box;

  color: ${({ theme }) => theme.color};

  overflow: hidden;
`;

export const Tabs = styled.div`
  display: flex;
  align-items: center;
`;

export const Tab = styled.button`
  position: relative;

  padding: 14px 20px;

  border: none;
  background: transparent;

  color: ${({ theme, $active }) =>
    $active ? theme.primary : theme.grey};

  font-size: 14px;
  font-weight: ${({ $active }) =>
    $active ? 600 : 500};

  cursor: pointer;

  transition:
    color 0.2s ease,
    background-color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.primary};

    background-color: ${({ theme }) =>
      theme.containerHover};
  }

  &::after {
    content: '';

    position: absolute;
    left: 12px;
    right: 12px;
    bottom: -1px;

    height: 2px;

    background-color: ${({ theme }) =>
      theme.primary};

    transform: scaleX(
      ${({ $active }) => ($active ? 1 : 0)}
    );

    transition: transform 0.2s ease;
  }
`;

export const Content = styled.div`
  padding: 20px;
  overflow-y: auto;
  max-height: 500px;
`;

export const FieldsGrid = styled.div`
  display: grid;

  grid-template-columns: repeat(2, minmax(0, 1fr));

  column-gap: 32px;
  row-gap: 18px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  min-width: 0;

  ${({ $fullWidth }) =>
    $fullWidth &&
    `
      grid-column: 1 / -1;
    `}
`;

export const Label = styled.div`
  margin-bottom: 5px;

  color: ${({ theme }) => theme.inputLabel};

  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
`;

export const Value = styled.div`
  color: ${({ theme }) => theme.color};

  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;

  word-break: break-word;
`;

export const EmptyValue = styled.div`
  color: ${({ theme }) => theme.grey};

  font-size: 14px;
  line-height: 1.5;
`;

export const BooleanValue = styled.div`
  display: inline-flex;

  align-items: center;
  justify-content: center;

  width: 22px;
  height: 22px;

  border-radius: 50%;

  color: ${({ theme, $enabled }) =>
    $enabled ? theme.success : theme.error};

  font-size: 14px;
  font-weight: 700;
`;

export const List = styled.ul`
  display: flex;
  flex-wrap: wrap;

  gap: 6px;

  margin: 0;
  padding: 0;

  list-style: none;
`;

export const ListItem = styled.li`
  padding: 4px 8px;

  border-radius: 4px;

  background-color: ${({ theme }) =>
    theme.selectEven};

  border: 1px solid ${({ theme }) =>
    theme.containerLine};

  color: ${({ theme }) => theme.color};

  font-size: 12px;
  line-height: 1.4;

  word-break: break-word;
`;